<template>
  <common-panel :panel-data="panelData"></common-panel>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";
export default {
  name: "WarningProfile",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        hasTree: true,
        treeProps: {
          children: 'childNode',
          label: 'name'
        },
        treeMethod: this.$api.systemManage.getSensorTree,
        queryMethod: this.$api.energyMonitor.getLimitInfo,
        filterForm: [
          {
            label: '感知器名称：', prop: 'sensorName', type: 'input', value: '', style: 'width: 160px;'
          },
          {
            label: '限值类型：', prop: 'limType', type: 'select', value: 0, style: 'width: 120px;margin-right: 36px;',
            props: {value: 'value', label: 'label'},
            options: [{value: 0, label: '所有'}, {value: 1, label: '越上限'}, {value: -1, label: '越下限'}
            ]
          }
        ],
        buttons: [
          {label: '新增', icon: 'zy-icon-plus', type: 'add', handleIndex: -1},
          {label: '修改', icon: 'zy-icon-edit', type: 'edit', handleIndex: -2, text: true},
          {label: '删除', icon: 'zy-icon-delete', type: 'del', handleIndex: 1}
        ],
        methods: {
          query_prop: 'id',
          query_id: 'id',
          add: this.$api.energyMonitor.addLimitInfo,
          edit: this.$api.energyMonitor.updateLimitInfo,
          del: this.$api.energyMonitor.deleteLimitInfo,
          del_prop: 'id'
        },
        tableCheck: true,
        tableTitle: '限值设置列表',
        tableProps: [
          {prop: "sensorName", label: "感知器名称"},
          {prop: "dataName", label: "数据项名称"},
          {prop: "typeName", label: "限值类型"},
          {prop: "dataLim", label: "限值"}
        ],
        dialogs: {
          add_edit: {
            title: '限值设置信息',
            width: '600px',
            editFlag: false,
            items: [
              {type: 'select', prop: 'sensorId', label: '感知器：', placeholder: '选择感知器', style: 'width: 200px; margin-right: 120px;', editable: true,
                method: this.$api.systemManage.getSensorList,
                props: {value: 'id', label: 'sensorName'},
                options: [],
                changeMethod: this.$api.systemManage.getSensorData,
                changeIndex: 1
              },
              {type: 'select', prop: 'dataId', label: '数据项：', placeholder: '选择数据项', style: 'width: 200px;', editable: true,
                props: {value: 'id', label: 'dataName'},
                options: []
              },
              {type: 'select', prop: 'limType', label: '限值类型：', placeholder: '选择限值类型', style: 'width: 200px; margin-right: 120px', editable: true,
                method: this.$api.systemManage.getLimitType,
                props: {value: 'id', label: 'typeName'},
                options: []
              },
              {type: 'input', prop: 'dataLim', label: '限值：', placeholder: '请输入限值', style: 'width: 200px;'}
            ],
            rules: {
              sensorId: [
                {required: true, message: '请选择感知器', trigger: 'blur'}
              ],
              dataId: [
                {required: true, message: '请选择数据项', trigger: 'blur'}
              ],
              limType: [
                {required: true, message: '请选择限值类型', trigger: 'blur'}
              ],
              dataLim: [
                {required: true, message: '请输入限值', trigger: 'blur'}
              ]
            },
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/WarningManage/WarningProfile.vue